/**
 * PATH: apps/qa/src/lib/qaQDriveList.ts
 * FILE_ID: QA-HUB-QDRIVE-LIST-001
 * PURPOSE: Same QDrive list/search the jobs-door photo picker uses.
 */
import { qdrivePickerFilesFromResponse, type QaJobFile } from '@quotech/job-hub/jobs/qa'
import api from '@/lib/api'

export async function listQaQDriveFiles(query?: string): Promise<QaJobFile[]> {
  const q = query?.trim()
  const response = q
    ? await api().get('/qdrive/search/', { params: { q } })
    : await api().get('/qdrive/files/', { params: { page_size: 50, ordering: '-uploaded_at' } })
  return qdrivePickerFilesFromResponse(response.data)
}
